import { useTypedSelector } from "../store";
import UserInfoForm from "../forms/UserInfoForm";
import ChangePasswordForm from "../forms/ChangePasswordForm";
import AddressesList from "../components/features/AddressesList";

const Profile = () => {
  const user = useTypedSelector((state) => state.session.user);

  if (!user) return <div>Non connecté</div>;

  return (
    <div className="container mx-auto p-4 max-w-4xl">
      <h1 className="text-3xl font-bold mb-8 text-center text-primary">
        Mon Profil
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <UserInfoForm />
        <ChangePasswordForm />
      </div>

      <AddressesList />
    </div>
  );
};

export default Profile;
